import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {moduloHorasExtras} from '../../diccionarios/horas-extrasModulo.js';
import {ParametrizacionFeriadosService} from "../../services/parametrizacion-feriado.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {UtilsService} from "../../../../shared/utils/utils.service";
import * as _ from 'lodash';

@Component({
  selector: 'app-parametrizacion-feriados',
  templateUrl: './parametrizacion-feriados.component.html',
  styleUrls: ['./parametrizacion-feriados.component.css']
})
export class ParametrizacionFeriadosComponent implements OnInit {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbLocalizaciones: any[];
  cmbTipos: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionFeriado: ParametrizacionFeriadosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionFeriados;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.getToday();
    this.formulario = this.fb.group({
      id: [''],
      tipo: ['', [Validators.required]],
      localidad: [''],
      fecha: ['', [Validators.required,]]
    });
    this.cmbTipos = [
      {
        id: 1,
        descripcion: "Nacional"
      },
      {
        id: 2,
        descripcion: "Local"
      },
    ];
    this.girdComponent();
    this.getAllFeriados();
  }

  getToday() {
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    this.today = `${year}-${month}-${day < 10 ? '0' + day : day}`;
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.formulario.reset();
    this.getFormInfo();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllFeriados() {
    this.loading = true;
    this._parametrizacionFeriado.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  getFormInfo(rowData?) {
    this.loading = true;
    this._parametrizacionFeriado.getAllLocalizaciones().subscribe((res: any) => {
      this.cmbLocalizaciones = res;
      if (this.editableForm) {
        const payload = this.formatData(rowData);
        this.formulario.setValue(payload);
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbLocalizaciones = [];
    });
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'TIPO',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'LOCALIDAD',
        field: 'localidad.localidad',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarFeriado.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarFeriado({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.getFormInfo(rowData);
  }

  formatData(data) {
    let rowData = _.cloneDeep(data);
    if (rowData.tipo) {
      const tipo = this.cmbTipos.find(tipo => tipo.descripcion.trim().toLowerCase() === rowData.tipo.trim().toLowerCase());
      rowData.tipo = tipo.id;
    }
    if (rowData.localidad) {
      const localidad = this.cmbLocalizaciones.find(localidad => localidad.localidad.trim().toLowerCase() === rowData.localidad.localidad.trim().toLowerCase());
      rowData.localidad = localidad.codigo;
    }
    return rowData;
  }

  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._parametrizacionFeriado.borrarFeriado(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarFeriado();
      } else {
        this.guardarFeriado();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarFeriado() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionFeriado.actualizarFeriado(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllFeriados();
      this.regresar();
    });
  }

  changeTipo() {
    this.formulario.get('localidad').setValue(null);
    if (!this.formulario.get('tipo').value || this.formulario.get('tipo').value === 1) {
      this.formulario.get('localidad').setValidators(null);
      this.obligatorylocality = false;
    } else {
      this.formulario.get('localidad').setValidators([Validators.required]);
      this.obligatorylocality = true;
    }
    this.formulario.get('localidad').updateValueAndValidity();
  }

  guardarFeriado() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._parametrizacionFeriado.guardarFeriado(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllFeriados();
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

}
